import React from "react";
import NoResultsWithButton from "components/noResultsWithButton/NoResultsWithButton";

export interface FlowsNoResultsProps {
  byCriteria?: boolean;
  createFlowButton?: React.ReactElement;
  title?: string;
  description?: string;
}

function FlowsNoResults(props: FlowsNoResultsProps) {
  const { byCriteria, createFlowButton, title, description } = props;

  return (
    <NoResultsWithButton
      title={title || "You don't have any flows"}
      description={description || "Looks like you don't have any flows yet."}
      iconClassName="fa-code-branch outline"
      actionButton={createFlowButton}
      filtered={byCriteria}
    />
  );
}

export default FlowsNoResults;
